import axios from 'axios'
import { ErrorService } from './error.service'
import formatter from '@/mixins/formatter'

const ApiService = {

  async get (endpoint, config = {}) {
    return new Promise((resolve, reject) => {
      axios.get(endpoint, config)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  },

  async getObject (endpoint, payload, config = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpoint}?${formatter.methods.objectToUrl(payload)}`, config)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  },

  async post (endpoint, payload, config = {}) {
    return new Promise((resolve, reject) => {
      axios.post(endpoint, payload, config)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  },

  async put (endpoint, payload, config = {}) {
    return new Promise((resolve, reject) => {
      axios.put(endpoint, payload, config)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  },

  async delete (endpoint, config = {}) {
    return new Promise((resolve, reject) => {
      axios.delete(endpoint, config)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(ErrorService.transformError(error))
        })
    })
  }
}

export default ApiService
